import React, { useState, useEffect } from 'react';
import { RenderInBody } from 'bv-components';
import { v as bvVar } from 'bv';
import SmartAppBanner from './smart_app_banner';
import displayBanner from './helpers/display_banner';

const smartAppBannerData = bvVar('smartAppBanner');

export default () => {
  if (!smartAppBannerData) return null;

  const { visibility, ...rest } = smartAppBannerData;
  const [showBanner, setShowBanner] = useState(displayBanner(visibility));

  useEffect(() => {
    document.body.classList[showBanner ? 'add' : 'remove']('smartbanner--show');
  }, [showBanner]);

  if (!showBanner) return null;

  return (
    <RenderInBody>
      <SmartAppBanner
        setShowBanner={setShowBanner}
        {...rest}
      />
    </RenderInBody>
  );
};
